import { Fancybox } from "@fancyapps/ui";
import Cookies from 'js-cookie';
import initSubmitForm from "../forms/forms.js";

const POPUP_TIMER_MS = 45000;  // Таймер для открытия попапа
const WIDGET_TIMER_MS = 4000;  // Таймер для показа виджета
const COOKIE_EXPIRY_DAYS = 1; // Время действия куки в сутках
const COOKIE_NAME = 'widget_phone_popup_show';

// HTML-контент виджета
const WIDGET_HTML = `
    <div class="widget-phone-wrap">
        <button data-fancybox data-type="ajax" class="widget-phone" data-src="/form_fmc/api/popap/?ext_key=eafb5f6a93f97492d06541dc5da00ee3&ext_var[name]=value&tpl_var=widget_phone" title="Обратный звонок">
            <span class="widget__circles">
                <svg><use xlink:href="img/sprite.svg#phone"></use></svg>
            </span>
        </button>
    </div>
`;

const widgetPhone = () => {
    document.addEventListener("DOMContentLoaded", () => {
        initializeWidgetPhone();

        try {
            Fancybox.bind("[data-fancybox].widget-phone", {
                dragToClose: !window.isMobile, // bug: click to button misses on mobile
                on: {
                    reveal: (fancybox, slide) => {
                        const formId = slide.el.querySelector('form')?.id;
                        if (formId) {
                            initSubmitForm(formId);
                        }
                    },
                    close: () => {
                        // показать значок при закрытии попапа
                        document.querySelector('.widget-phone')?.classList.add('widget-phone__active');
                    },
                },
            });
        } catch (error) {
            console.error('Fancybox widgetPhone initialization error:', error);
        }
    });
};

const initializeWidgetPhone = () => {
    let widgetPopupOpenFlag = false; // Флаг открытия попапа

    document.body.insertAdjacentHTML('afterbegin', WIDGET_HTML);

    const widgetPhone = document.querySelector('.widget-phone');

    if (!widgetPhone) return;

    setTimeout(() => {
        widgetPhone.classList.add('widget-phone__active');
    }, WIDGET_TIMER_MS);

    widgetPhone.addEventListener('click', () => {
        handleWidgetPhoneClick(widgetPhone, COOKIE_EXPIRY_DAYS, widgetPopupOpenFlag);
    });

    // Проверка куки и таймер для открытия попапа
    if (!Cookies.get('widget_phone_popup_show')) {
        setTimeout(() => {
            // если попап не открывали вручную и в данный момент не открыто никакого другого попапа
            if (!widgetPopupOpenFlag && !document.documentElement.classList.contains('with-fancybox')) {
                handleWidgetPhoneClick(widgetPhone, COOKIE_EXPIRY_DAYS, widgetPopupOpenFlag, true);
            }
        }, POPUP_TIMER_MS);
    }
};

const handleWidgetPhoneClick = (widgetPhone, cookieExpiryDays, widgetPopupOpenFlag, autoOpen = false) => {
    widgetPopupOpenFlag = true;

    // если попап вызывается автоматически, а не кликом по кнопке, то скриптом кликаем по кнопке
    if (!Cookies.get('widget_phone_popup_show') && autoOpen) {
        widgetPhone.click();
    }

    widgetPhone.classList.remove('widget-phone__active');

    try {
        Cookies.set(COOKIE_NAME, 'true', { expires: cookieExpiryDays });
    } catch (error) {
        console.error('Error setting cookie:', error);
    }
};

export default widgetPhone;
